<template>
  <metainfo></metainfo>
  <div class="container-xl">
    <div class="page-header d-print-none d-flex flex-row flex-nowrap align-items-center justify-content-center gap-2">
      <span>Копирование поста...</span>
      <span class="spinner-border spinner-border-sm" role="status"></span>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted} from "vue"
import {useMeta} from "vue-meta"
import {useRoute} from "vue-router"
import Api from "./services/Api"
import Helper from "@/services/Helper"
import Notify from "@/services/Notify"
import { useRouter } from 'vue-router'

export default defineComponent({
  name: "PostDuplicate",
  components: {},
  setup() {
    useMeta({title: "Копирование поста"})

    const route = useRoute()
    const router = useRouter()

    onMounted(async () => {
      let postId = parseInt(route.query.post_id)
      let channelId = parseInt(route.params.channel_id)

      if (!Helper.isInt(postId) || !Helper.isInt(channelId)) {
        Notify.error("Ошибка параметров")
        return
      }

      let resp = await Api.telegramDuplicate(postId, channelId)

      let id = resp?.item?.post_id ?? null

      await router.push({name: 'PostUpdate', params: {id: id}})
    })

    return {}
  },
})
</script>
